import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient, type MerchantScopedRequest} from "../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../stem-core/state/State";
import {Merchant} from "../MerchantStore";
import {MerchantEmailSender} from "./MerchantEmailSender";
import type {StemDate} from "../../../stem-core/time/Date";


@globalStore
export class MerchantEmailingSettings extends BaseStore("MerchantEmailingSettings") {
    @field("Merchant") merchant: Merchant;
    @field("MerchantEmailSender") defaultSender: MerchantEmailSender;
    @field(String) emailReplyTo: string;
    @field(Array) bccEmails: string[];
    @field(Boolean) sendDonationCancelEmail: boolean;
}

// UpdateMerchantEmailingSettingsRequest (api/merchants/views.py)
export interface UpdateMerchantEmailingSettingsRequest extends MerchantScopedRequest {
    defaultSenderId?: StoreId;
    emailReplyTo?: string;
    bccEmails?: string[];
}

export async function apiUpdateMerchantEmailingSettings(request: UpdateMerchantEmailingSettingsRequest): Promise<any> {
    return apiClient.post("merchant/update_emailing_settings/", request);
}

// What GetEmailingBreakdownRequest validates (dashboard/deserializers.py:81). The dates default to the
// last 32 days; audienceIds left out means every audience
export interface GetEmailingBreakdownRequest extends MerchantScopedRequest {
    startDate?: StemDate;
    endDate?: StemDate;
    includeStart?: boolean;
    includeEnd?: boolean;
    audienceIds?: StoreId[];
}

// query_merchant_emailing_breakdown on the backend, with EmailMessagesStats spread in
export interface EmailingBreakdown {
    subscribersCount: number;
    unsubscribersCount: number;
    // The server sends the date as a string; the dashboard swaps in a StemDate once it has the response
    dateHistogram: {date: string | StemDate; subscribersCount: number; unsubscribersCount: number}[];
    numSentEmails: number;
    numReadEmails: number;
    numBouncedEmails: number;
    numFailedEmails: number;
    totalNumReads: number;
}

export async function apiMerchantEmailingBreakdown(request: GetEmailingBreakdownRequest): Promise<EmailingBreakdown> {
    return apiClient.get("/merchant/get_emailing_breakdown/", request);
}
